import { useBreakpointValue } from "@chakra-ui/react";
import { GoogleMap } from "@react-google-maps/api";
import PropTypes from "prop-types";
import { useRef, useState } from "react";

import { useGoogleMapsLoaded } from "@/hooks/useGoogleMapsLoaded";

const Map = ({
    children,
    isFullWidth,
    containerStyle = {
        width: "100%",
        height: "100%",
    },
    center = { lat: 20.6596988, lng: -103.3496092 },
    zoom = 10,
    onZoomChanged = (z) => z,
    ...props
}) => {
    const ref = useRef(null);
    const [load, setLoad] = useState(false);
    const isLoaded = useGoogleMapsLoaded();
    const isSmallScreen = useBreakpointValue({
        base: true,
        md: false,
    });

    // GoogleMap needs the Maps script; the app no longer gates globally.
    if (!isLoaded) {
        return null;
    }

    return (
        <GoogleMap
            {...props}
            mapContainerStyle={{
                ...containerStyle,
                width: isFullWidth || isSmallScreen ? "90vw" : "100%",
                marginTop: isFullWidth || isSmallScreen ? "0px" : "30px",
            }}
            center={center}
            zoom={zoom}
            onZoomChanged={(z) => {
                try {
                    onZoomChanged(ref.current.getZoom());
                } catch (error) {
                    onZoomChanged(zoom);
                }
            }}
            onLoad={(m) => {
                setLoad(true);
                ref.current = m;
            }}
        >
            {load ? children : null}
        </GoogleMap>
    );
};

Map.propTypes = {
    containerStyle: PropTypes.object,
    center: PropTypes.object,
    zoom: PropTypes.number,
    onZoomChanged: PropTypes.func,
};

export default Map;
